var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"field"},[_c('Select',{attrs:{"id":_vm.id,"label":_vm.label,"options":_vm.options,"error":_vm.error,"error-message":_vm.errorMessage,"disabled":_vm.disabled,"helper":_vm.helper,"loading":_vm.loading},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }